(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 21964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DenomInput; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4296);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89342);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82206);
/* harmony import */ var _components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32685);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57333);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["denom", "value", "onChange", "type", "defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function DenomInput(_ref) {
  var denom = _ref.denom,
      value = _ref.value,
      onChange = _ref.onChange,
      type = _ref.type,
      defaultValue = _ref.defaultValue,
      props = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var handleChange = function handleChange(values) {
    onChange(values.floatValue);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .InputGroup */ .B, {
    children: [denom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .InputLeftElement */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        denomInfo: denom
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, _objectSpread({
      pl: denom ? 10 : undefined,
      placeholder: "Enter amount",
      customInput: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .I,
      allowNegative: false,
      onValueChange: handleChange,
      value: value,
      defaultValue: defaultValue,
      thousandSeparator: ","
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .InputRightElement */ .x, {
      textStyle: "body-xs",
      w: "min-content",
      p: 3,
      children: denom === null || denom === void 0 ? void 0 : denom.name
    })]
  });
}

/***/ }),

/***/ 39233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Radio; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73636);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Radio(_ref) {
  var children = _ref.children,
      props = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .U, _objectSpread(_objectSpread({
    bg: "abyss.200",
    w: "max-content",
    borderRadius: "2xl",
    px: 1,
    py: 1,
    spacing: 1
  }, props), {}, {
    children: children
  }));
}

/***/ }),

/***/ 9126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RadioCard; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80986);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26972);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68029);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["disabledMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function RadioCard(_ref) {
  var disabledMessage = _ref.disabledMessage,
      props = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var children = props.children,
      borderRadius = props.borderRadius,
      isDisabled = props.isDisabled;

  var _useRadio = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useRadio */ .x)(props),
      getInputProps = _useRadio.getInputProps,
      getRadioProps = _useRadio.getRadioProps,
      htmlProps = _useRadio.htmlProps,
      getLabelProps = _useRadio.getLabelProps;

  var input = getInputProps();
  var radio = getRadioProps();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u, {
    label: isDisabled ? disabledMessage : '',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, _objectSpread(_objectSpread({
      as: "label"
    }, htmlProps), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread({}, input)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, _objectSpread(_objectSpread({}, radio), {}, {
        cursor: "pointer",
        px: 2,
        _checked: {
          bg: 'blue.200',
          color: 'navy'
        },
        borderRadius: borderRadius || '2xl',
        _focus: {
          boxShadow: 'outline'
        },
        _disabled: {
          opacity: 0.4,
          cursor: 'not-allowed'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, _objectSpread(_objectSpread({}, getLabelProps()), {}, {
          children: children
        }))
      }))]
    }))
  });
}

/***/ }),

/***/ 18428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SummaryAgreementForm; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83658);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3712);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90092);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(38488);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54506);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54795);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73064);
/* harmony import */ var _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52597);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82580);
/* harmony import */ var _components_Submit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9685);
/* harmony import */ var _components_TermsModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37930);
/* harmony import */ var _AgreementCheckbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









function SummaryAgreementForm(_ref) {
  var isError = _ref.isError,
      error = _ref.error,
      onSubmit = _ref.onSubmit,
      isDisabled = _ref.isDisabled;

  var _useDisclosure = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .q)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var validate = function validate(values) {
    if (!values.acceptedAgreement) {
      return {
        acceptedAgreement: 'You must accept the terms and conditions before continuing.'
      };
    }

    return {};
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Formik */ .J9, {
    initialValues: {
      acceptedAgreement: false
    },
    validate: validate,
    onSubmit: onSubmit,
    children: function children(_ref2) {
      var acceptedAgreement = _ref2.values.acceptedAgreement;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
          spacing: 4,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_AgreementCheckbox__WEBPACK_IMPORTED_MODULE_4__/* .AgreementCheckbox */ .k, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
              textStyle: "body-xs",
              children: ["I have read and agree to be bound by the", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                textDecoration: "underline",
                fontWeight: "normal",
                size: "xs",
                display: "inline-flex",
                colorScheme: "blue",
                variant: "unstyled",
                onClick: onOpen,
                children: "CALC Terms & Conditions."
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .FormControl */ .NI, {
            isInvalid: isError,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Submit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              w: "full",
              type: "submit",
              rightIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_1__/* .CheckedIcon */ .YJ9,
                stroke: "navy"
              }),
              isDisabled: isDisabled || !acceptedAgreement,
              children: "Confirm"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .FormErrorMessage */ .J1, {
              children: ["Failed to create strategy (Reason: ", error === null || error === void 0 ? void 0 : error.message, ")"]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_TermsModal__WEBPACK_IMPORTED_MODULE_3__/* .TermsModal */ .X, {
            showCheckbox: false,
            isOpen: isOpen,
            onClose: onClose
          })]
        })
      });
    }
  });
}

/***/ }),

/***/ 2248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18459);

var simpleDcaInSteps = [{
  href: '/',
  title: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .contentData.dcaIn.assets.title */ .fS.dcaIn.assets.title
}, {
  href: '/',
  title: 'Strategy Created!',
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (simpleDcaInSteps);

/***/ }),

/***/ 58112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ checkSwapAmountValue; }
/* harmony export */ });
/* harmony import */ var _format_formatFiat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50215);
/* harmony import */ var _chains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87038);


function checkSwapAmountValue(chainId, swapAmount, price) {
  if (false) {}
  var swapAmountValue = swapAmount * price;
  var minimumSwapAmount = (0,_chains__WEBPACK_IMPORTED_MODULE_1__/* .getChainMinimumSwapValue */ .Jd)(chainId);

  if (!(swapAmountValue >= minimumSwapAmount)) {
    throw new Error("Minimum swap amount must be greater than ".concat((0,_format_formatFiat__WEBPACK_IMPORTED_MODULE_0__/* .formatFiat */ .M)(minimumSwapAmount)));
  }
}

/***/ }),

/***/ 63961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ executionIntervalLabel; }
/* harmony export */ });
var executionIntervalDisplay = {
  minute: ['minute', 'minutes'],
  half_hourly: ['half hour', 'half hours'],
  hourly: ['hour', 'hours'],
  daily: ['day', 'days'],
  half_daily: ['half day', 'half days'],
  weekly: ['week', 'weeks'],
  fortnightly: ['fortnight', 'fortnights'],
  monthly: ['month', 'months']
};
var executionIntervalLabel = {
  minute: 'Every minute',
  half_hourly: 'Half-hourly',
  hourly: 'Hourly',
  daily: 'Daily',
  half_daily: 'Half-daily',
  weekly: 'Weekly',
  fortnightly: 'Fortnightly',
  monthly: 'Monthly'
};
/* harmony default export */ __webpack_exports__["Z"] = (executionIntervalDisplay);

/***/ }),

/***/ 18437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ findPair; }
/* harmony export */ });
/* harmony import */ var _utils_pair__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17987);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83706);


function findPair(pairs, resultingDenom, initialDenom) {
  var initialAsQuote = (0,rambda__WEBPACK_IMPORTED_MODULE_0__/* .find */ .s)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getBaseDenom */ .m)(pair).id === resultingDenom.id && (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteDenom */ .v)(pair).id === initialDenom.id;
  }, pairs);

  if (initialAsQuote) {
    return initialAsQuote;
  }

  return (0,rambda__WEBPACK_IMPORTED_MODULE_0__/* .find */ .s)(function (pair) {
    return (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getBaseDenom */ .m)(pair).id === initialDenom.id && (0,_utils_pair__WEBPACK_IMPORTED_MODULE_1__/* .getQuoteDenom */ .v)(pair).id === resultingDenom.id;
  }, pairs);
}

/***/ }),

/***/ 34886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ formatDate; }
/* harmony export */ });
function formatDate(date) {
  if (!date) {
    return '-';
  }

  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

/***/ }),

/***/ 22349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getEndDateFromRemainingExecutions; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86831);

function getEndDateFromRemainingExecutions(strategy, startDate, remainingExecutions) {
  if ((0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(strategy.rawData.time_interval) === 'object') {
    var customIncrements = strategy.rawData.time_interval.custom.seconds;
    startDate.setSeconds(startDate.getSeconds() + customIncrements * remainingExecutions);
    return startDate;
  }

  switch (strategy.rawData.time_interval) {
    case 'minute':
      startDate.setMinutes(startDate.getMinutes() * remainingExecutions);
      break;

    case 'half_hourly':
      startDate.setMinutes(startDate.getMinutes() + 30 * remainingExecutions);
      break;

    case 'hourly':
      startDate.setHours(startDate.getHours() + remainingExecutions);
      break;

    case 'daily':
      startDate.setDate(startDate.getDate() + remainingExecutions);
      break;

    case 'half_daily':
      startDate.setHours(startDate.getHours() + 12 * remainingExecutions);
      break;

    case 'weekly':
      startDate.setDate(startDate.getDate() + 7 * remainingExecutions);
      break;

    case 'monthly':
      startDate.setMonth(startDate.getMonth() + remainingExecutions);
      break;

    default:
      return undefined;
  }

  return startDate;
}

/***/ }),

/***/ 84333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getTimeSaved; }
/* harmony export */ });
/* harmony import */ var _utils_totalExecutions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66260);

var TIME_SAVED_PER_SWAP = 10;
function getTimeSaved(deposit, swapAmount) {
  return (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deposit, swapAmount) * TIME_SAVED_PER_SWAP;
}

/***/ }),

/***/ 6686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mc": function() { return /* binding */ getAveragePurchasePrice; },
  "rY": function() { return /* binding */ getAverageSellPrice; },
  "HF": function() { return /* binding */ getBasePrice; },
  "I9": function() { return /* binding */ getNextTargetTime; },
  "a5": function() { return /* binding */ getPriceThreshold; },
  "OJ": function() { return /* binding */ getSlippageTolerance; },
  "oY": function() { return /* binding */ getSlippageToleranceFormatted; },
  "uo": function() { return /* binding */ getStrategyBalance; },
  "AO": function() { return /* binding */ getStrategyEndDate; },
  "FN": function() { return /* binding */ getStrategyEndDateFromRemainingExecutions; },
  "H0": function() { return /* binding */ getStrategyExecutionInterval; },
  "ps": function() { return /* binding */ getStrategyExecutionIntervalData; },
  "vB": function() { return /* binding */ getStrategyInitialDenom; },
  "LR": function() { return /* binding */ getStrategyName; },
  "Cx": function() { return /* binding */ getStrategyPriceTrigger; },
  "wW": function() { return /* binding */ getStrategyRemainingExecutions; },
  "xT": function() { return /* binding */ getStrategyResultingDenom; },
  "sS": function() { return /* binding */ getStrategyStartDate; },
  "dC": function() { return /* binding */ getStrategyType; },
  "Pg": function() { return /* binding */ getSwapAmount; },
  "bX": function() { return /* binding */ getTargetPrice; },
  "ZD": function() { return /* binding */ getTotalReceived; },
  "pG": function() { return /* binding */ getTotalReceivedBeforeFees; },
  "cc": function() { return /* binding */ getTotalSwapped; },
  "sh": function() { return /* binding */ isBuyStrategy; },
  "KT": function() { return /* binding */ isStrategyActive; },
  "WD": function() { return /* binding */ isStrategyAutoStaking; },
  "iF": function() { return /* binding */ isStrategyCancelled; },
  "sf": function() { return /* binding */ isStrategyCompleted; },
  "KF": function() { return /* binding */ isStrategyOperating; },
  "Qs": function() { return /* binding */ isStrategyScheduled; }
});

// UNUSED EXPORTS: convertReceiveAmount, getStrategyInitialDenomId, getStrategyTotalFeesPaid

// EXTERNAL MODULE: ./src/models/Strategy.ts
var Strategy = __webpack_require__(22149);
// EXTERNAL MODULE: ./src/models/StrategyType.tsx
var StrategyType = __webpack_require__(94705);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./src/utils/totalExecutions.tsx
var totalExecutions = __webpack_require__(66260);
// EXTERNAL MODULE: ./src/helpers/findPair.ts
var findPair = __webpack_require__(18437);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
// EXTERNAL MODULE: ./src/utils/pair.ts
var utils_pair = __webpack_require__(17987);
// EXTERNAL MODULE: ./src/utils/safeInvert.tsx
var safeInvert = __webpack_require__(90019);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/helpers/executionIntervalDisplay.tsx
var executionIntervalDisplay = __webpack_require__(63961);
// EXTERNAL MODULE: ./src/helpers/format/formatDate.tsx
var formatDate = __webpack_require__(34886);
// EXTERNAL MODULE: ./src/helpers/getEndDateFromRemainingExecutions.tsx
var getEndDateFromRemainingExecutions = __webpack_require__(22349);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/helpers/getLastExecutionDateFromStrategyEvents.tsx

function getLastExecutionDateFromStrategyEvents(events) {
  var lastExecutionEvent = (0,lodash.findLast)(events, function (event) {
    var data = event.data;

    if ('dca_vault_execution_triggered' in data) {
      return data.dca_vault_execution_triggered;
    }

    return false;
  }); // vault has no executions yet

  if (!lastExecutionEvent) {
    return undefined;
  }

  return new Date(Number(lastExecutionEvent.timestamp) / 1000000);
}
;// CONCATENATED MODULE: ./src/helpers/isAutoStaking.ts
function isAutoStaking(destinations) {
  return destinations.length > 0 && destinations[0].address.startsWith('kujiravaloper');
}
// EXTERNAL MODULE: ./src/helpers/strategy/isWeightedScale/index.ts
var isWeightedScale = __webpack_require__(19766);
// EXTERNAL MODULE: ./src/helpers/strategy/isDcaPlus/index.ts
var strategy_isDcaPlus = __webpack_require__(67207);
;// CONCATENATED MODULE: ./src/helpers/strategy/index.ts

















function isStrategyOperating(strategy) {
  return strategy.status === Strategy/* StrategyStatus.ACTIVE */.L.ACTIVE || strategy.status === Strategy/* StrategyStatus.SCHEDULED */.L.SCHEDULED;
}
function isStrategyActive(strategy) {
  return strategy.status === Strategy/* StrategyStatus.ACTIVE */.L.ACTIVE;
}
function isStrategyScheduled(strategy) {
  return strategy.status === Strategy/* StrategyStatus.SCHEDULED */.L.SCHEDULED;
}
function isStrategyCompleted(strategy) {
  return strategy.status === Strategy/* StrategyStatus.COMPLETED */.L.COMPLETED;
}
function isStrategyCancelled(strategy) {
  return strategy.status === Strategy/* StrategyStatus.CANCELLED */.L.CANCELLED;
}
function getStrategyBalance(strategy) {
  var _ref = strategy.rawData || {},
      balance = _ref.balance;

  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.initialDenom, Number(balance.amount));
}
function getStrategyInitialDenomId(strategy) {
  return strategy.rawData.balance.denom;
}
function getStrategyInitialDenom(strategy) {
  return strategy.initialDenom;
}
function getStrategyResultingDenom(strategy) {
  return strategy.resultingDenom;
}
function getStrategyExecutionIntervalData(strategy) {
  if (strategy.rawData.time_interval instanceof Object) {
    var custom = strategy.rawData.time_interval.custom;
    var weeks = Math.floor(custom.seconds / constants/* SECONDS_IN_A_DAY */.K5 / constants/* DAYS_IN_A_WEEK */.Yx);
    var days = Math.floor(custom.seconds / constants/* SECONDS_IN_A_HOUR */.sb / constants/* HOURS_IN_A_DAY */.C4);
    var hours = Math.floor(custom.seconds / constants/* SECONDS_IN_A_MINUTE */.JJ / constants/* MINUTES_IN_A_HOUR */.Jh);
    var minutes = Math.floor(custom.seconds / constants/* SECONDS_IN_A_MINUTE */.JJ);

    if (custom) {
      if (custom.seconds % constants/* SECONDS_IN_A_WEEK */.Jp === 0) {
        return {
          timeInterval: 'weekly',
          timeIncrement: weeks
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_DAY */.K5 === 0) {
        return {
          timeInterval: 'daily',
          timeIncrement: days
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_HOUR */.sb === 0) {
        return {
          timeInterval: 'hourly',
          timeIncrement: hours
        };
      }

      if (custom.seconds % constants/* SECONDS_IN_A_MINUTE */.JJ === 0) {
        return {
          timeInterval: 'minute',
          timeIncrement: minutes
        };
      }
    }
  }

  var time_interval = strategy.rawData.time_interval;
  return {
    timeInterval: time_interval,
    timeIncrement: undefined
  };
}
function getStrategyExecutionInterval(strategy) {
  var _getStrategyExecution = getStrategyExecutionIntervalData(strategy),
      timeInterval = _getStrategyExecution.timeInterval,
      timeIncrement = _getStrategyExecution.timeIncrement;

  if (timeIncrement) {
    if (timeInterval === 'weekly') {
      return "".concat(timeIncrement, " Week");
    }

    if (timeInterval === 'daily') {
      return "".concat(timeIncrement, " Day");
    }

    if (timeInterval === 'hourly') {
      return "".concat(timeIncrement, " Hour");
    }

    if (timeInterval === 'minute') {
      return "".concat(timeIncrement, " Minute");
    }
  }

  return executionIntervalDisplay/* executionIntervalLabel */.y[timeInterval];
}
function getStrategyName(strategy) {
  if (strategy.rawData.label) {
    return strategy.rawData.label;
  }

  return "".concat(strategy.initialDenom.name, " to ").concat(strategy.resultingDenom.name, " - ").concat(getStrategyExecutionInterval(strategy));
}
function getSlippageTolerance(strategy) {
  var slippage_tolerance = strategy.rawData.slippage_tolerance;
  return slippage_tolerance ? Number((Number(slippage_tolerance) * 100).toFixed(2)) : undefined;
}
function getSlippageToleranceFormatted(strategy) {
  var slippageTolerance = getSlippageTolerance(strategy);
  return slippageTolerance ? "".concat(getSlippageTolerance(strategy), "%") : '-';
}
function getSwapAmount(strategy) {
  var _ref2 = strategy.rawData || {},
      swap_amount = _ref2.swap_amount;

  return Number(swap_amount);
}
function getStrategyType(strategy) {
  if ((0,isWeightedScale/* isWeightedScale */.U)(strategy)) {
    return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn : StrategyType/* StrategyType.WeightedScaleOut */.h.WeightedScaleOut;
  }

  if ((0,strategy_isDcaPlus/* isDcaPlus */.o)(strategy)) {
    return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn : StrategyType/* StrategyType.DCAPlusOut */.h.DCAPlusOut;
  }

  return (0,getDenomInfo/* isDenomStable */.dG)(strategy.initialDenom) ? StrategyType/* StrategyType.DCAIn */.h.DCAIn : StrategyType/* StrategyType.DCAOut */.h.DCAOut;
}
function getStrategyRemainingExecutions(strategy) {
  var balance = new bignumber/* default */.Z(strategy.rawData.balance.amount);
  var swapAmount = new bignumber/* default */.Z(strategy.rawData.swap_amount);
  return (0,totalExecutions/* default */.Z)(balance.toNumber(), swapAmount.toNumber());
}
function isBuyStrategy(strategy) {
  return getStrategyType(strategy) === StrategyType/* StrategyType.DCAIn */.h.DCAIn || getStrategyType(strategy) === StrategyType/* StrategyType.DCAPlusIn */.h.DCAPlusIn || getStrategyType(strategy) === StrategyType/* StrategyType.WeightedScaleIn */.h.WeightedScaleIn;
}
function getStrategyPriceTrigger(strategy) {
  var trigger = strategy.rawData.trigger;

  if (trigger && 'price' in trigger) {
    return trigger.price.target_price;
  }

  return undefined;
}
function getTargetPrice(strategy, pairs) {
  var target_price;

  if (getStrategyPriceTrigger(strategy)) {
    target_price = getStrategyPriceTrigger(strategy);
  }

  if (target_price) {
    var initialDenom = strategy.initialDenom,
        resultingDenom = strategy.resultingDenom;
    var pair = pairs && (0,findPair/* findPair */.d)(pairs, resultingDenom, initialDenom);

    if (pair && (0,utils_pair/* getBaseDenom */.m)(pair).id === strategy.initialDenom.id) {
      return (0,safeInvert/* safeInvert */.Z)(Number(target_price));
    }

    return Number(target_price);
  }

  return null;
}
function getNextTargetTime(strategy) {
  var started_at = strategy.rawData.started_at;
  var startTime = dayjs_min_default()(Number(started_at) / 1000000);
  var now = dayjs_min_default()();
  var diff = now.diff(startTime, 'seconds');

  if (strategy.rawData.time_interval instanceof Object) {
    var custom = strategy.rawData.time_interval.custom;

    var _iterations = Math.floor(diff / custom.seconds) + 1;

    return startTime.add(_iterations * custom.seconds, 'seconds').toDate();
  }

  var _getStrategyExecution2 = getStrategyExecutionIntervalData(strategy),
      timeInterval = _getStrategyExecution2.timeInterval;

  if (timeInterval === 'monthly') {
    var monthsDiff = now.diff(startTime, 'months') + 1;
    return startTime.add(monthsDiff, 'months').toDate();
  }

  var seconds = {
    minute: constants/* SECONDS_IN_A_MINUTE */.JJ,
    half_hourly: constants/* SECONDS_IN_A_HOUR */.sb / 2,
    hourly: constants/* SECONDS_IN_A_HOUR */.sb,
    half_daily: constants/* SECONDS_IN_A_DAY */.K5 / 2,
    daily: constants/* SECONDS_IN_A_DAY */.K5,
    weekly: constants/* SECONDS_IN_A_WEEK */.Jp,
    fortnightly: constants/* SECONDS_IN_A_WEEK */.Jp * 2
  }[timeInterval];
  var iterations = Math.floor(diff / seconds) + 1;
  return startTime.add(iterations * seconds, 'seconds').toDate();
}
function getStrategyStartDate(strategy, pairs) {
  var trigger = strategy.rawData.trigger;
  var initialDenom = strategy.initialDenom,
      resultingDenom = strategy.resultingDenom;
  var denom = isBuyStrategy(strategy) ? resultingDenom : initialDenom;
  var targetPrice = getTargetPrice(strategy, pairs);

  if (targetPrice) {
    var price = Number((0,getDenomInfo/* priceFromRatio */.Mb)(denom, targetPrice).toFixed(denom.pricePrecision));

    if (isBuyStrategy(strategy)) {
      return "When ".concat(resultingDenom.name, " hits ").concat(price, " ").concat(initialDenom.name);
    }

    return "When ".concat(initialDenom.name, " hits ").concat(price, " ").concat(resultingDenom.name);
  }

  if (isStrategyScheduled(strategy) && trigger && 'time' in trigger && trigger.time.target_time) {
    return new Date(Number(trigger.time.target_time) / 1000000).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  return strategy.rawData.started_at ? new Date(Number(strategy.rawData.started_at) / 1000000).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  }) : '-';
}
function getStrategyEndDateFromRemainingExecutions(strategy, events, executions) {
  var trigger = strategy.rawData.trigger;

  if (isStrategyScheduled(strategy) && trigger && 'time' in trigger) {
    var startDate = new Date(Number(trigger.time.target_time) / 1000000);
    return (0,formatDate/* formatDate */.p)((0,getEndDateFromRemainingExecutions/* getEndDateFromRemainingExecutions */.G)(strategy, startDate, executions));
  }

  if (!events) {
    return '-';
  }

  var lastExecutionDate = getLastExecutionDateFromStrategyEvents(events);

  if (isStrategyOperating(strategy) && lastExecutionDate) {
    return (0,formatDate/* formatDate */.p)((0,getEndDateFromRemainingExecutions/* getEndDateFromRemainingExecutions */.G)(strategy, lastExecutionDate, executions));
  }

  if (lastExecutionDate) {
    return lastExecutionDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });
  }

  return '-';
}
function getStrategyEndDate(strategy, events) {
  if (getStrategyPriceTrigger(strategy)) {
    return 'Pending strategy start';
  }

  var executions = getStrategyRemainingExecutions(strategy);
  return getStrategyEndDateFromRemainingExecutions(strategy, events, executions);
}
function isStrategyAutoStaking(strategy) {
  return isAutoStaking(strategy.rawData.destinations);
}
function convertReceiveAmount(strategy, receiveAmount) {
  var initialSF = strategy.initialDenom.significantFigures;
  var resultingSF = strategy.resultingDenom.significantFigures; // start with scaled receive amount

  var scaledReceiveAmount = Number(receiveAmount); // get unscaled receive amount

  var scalingFactor = 10 ** (resultingSF - initialSF);
  var unscaledReceiveAmount = scaledReceiveAmount / scalingFactor; // get directionless price

  var deconvertedSwapAmount = Number(getSwapAmount(strategy));
  var directionlessPrice = deconvertedSwapAmount / unscaledReceiveAmount; // get directed price

  var directedPrice = isBuyStrategy(strategy) ? directionlessPrice : (0,safeInvert/* safeInvert */.Z)(directionlessPrice);
  return Number(directedPrice.toFixed(6));
}
function getPriceThreshold(strategy) {
  if (!strategy.rawData.minimum_receive_amount) {
    return undefined;
  }

  return convertReceiveAmount(strategy, strategy.rawData.minimum_receive_amount);
}
function getBasePrice(strategy) {
  var _ref3 = (0,isWeightedScale/* getWeightedScaleConfig */.$)(strategy) || {},
      base_receive_amount = _ref3.base_receive_amount;

  if (!base_receive_amount) {
    return undefined;
  }

  return convertReceiveAmount(strategy, base_receive_amount);
}
function getStrategyTotalFeesPaid(strategy, dexFee) {
  var costAmount = strategy.rawData.swapped_amount.amount;
  var feeFactor = isDcaPlus(strategy) ? 0 : SWAP_FEE + dexFee + (isStrategyAutoStaking(strategy) ? DELEGATION_FEE : 0);
  return Number(costAmount) * feeFactor;
}
function getTotalSwapped(strategy) {
  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.initialDenom, Number(strategy.rawData.swapped_amount.amount));
}
function getTotalReceived(strategy) {
  return (0,getDenomInfo/* fromAtomic */.b1)(strategy.resultingDenom, Number(strategy.rawData.received_amount.amount));
}
function getTotalReceivedBeforeFees(strategy, dexFee) {
  var feeFactor = !(0,strategy_isDcaPlus/* isDcaPlus */.o)(strategy) ? constants/* SWAP_FEE */.OJ + dexFee : dexFee;
  return getTotalReceived(strategy) / (1 - feeFactor);
}
function getAverageSellPrice(strategy, dexFee) {
  return getTotalReceivedBeforeFees(strategy, dexFee) / getTotalSwapped(strategy);
}
function getAveragePurchasePrice(strategy, dexFee) {
  return getTotalSwapped(strategy) / getTotalReceivedBeforeFees(strategy, dexFee);
}

/***/ }),

/***/ 67207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ isDcaPlus; },
/* harmony export */   "u": function() { return /* binding */ getDcaPlusConfig; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function getDcaPlusConfig(strategy) {
  if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.performance_assessment_strategy) || (0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  var _strategy$rawData = strategy.rawData,
      swap_adjustment_strategy = _strategy$rawData.swap_adjustment_strategy,
      performance_assessment_strategy = _strategy$rawData.performance_assessment_strategy,
      deposited_amount = _strategy$rawData.deposited_amount,
      escrow_level = _strategy$rawData.escrow_level,
      escrowed_amount = _strategy$rawData.escrowed_amount;

  if ('risk_weighted_average' in swap_adjustment_strategy) {
    return {
      total_deposit: deposited_amount,
      standard_dca_received_amount: performance_assessment_strategy === null || performance_assessment_strategy === void 0 ? void 0 : performance_assessment_strategy.compare_to_standard_dca.received_amount,
      standard_dca_swapped_amount: performance_assessment_strategy === null || performance_assessment_strategy === void 0 ? void 0 : performance_assessment_strategy.compare_to_standard_dca.swapped_amount,
      escrow_level: escrow_level,
      escrowed_balance: escrowed_amount,
      model_id: swap_adjustment_strategy === null || swap_adjustment_strategy === void 0 ? void 0 : swap_adjustment_strategy.risk_weighted_average.model_id
    };
  }

  return null;
}
function isDcaPlus(strategy) {
  return Boolean(getDcaPlusConfig(strategy));
}

/***/ }),

/***/ 19766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ getWeightedScaleConfig; },
/* harmony export */   "U": function() { return /* binding */ isWeightedScale; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function getWeightedScaleConfig(strategy) {
  if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNil)(strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  if (!('weighted_scale' in strategy.rawData.swap_adjustment_strategy)) {
    return null;
  }

  var _strategy$rawData$swa = strategy.rawData.swap_adjustment_strategy.weighted_scale,
      base_receive_amount = _strategy$rawData$swa.base_receive_amount,
      increase_only = _strategy$rawData$swa.increase_only,
      multiplier = _strategy$rawData$swa.multiplier;
  return {
    base_receive_amount: base_receive_amount,
    increase_only: increase_only,
    multiplier: multiplier
  };
}
function isWeightedScale(strategy) {
  return Boolean(getWeightedScaleConfig(strategy));
}

/***/ }),

/***/ 67039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ useCalcSigningClient; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
// EXTERNAL MODULE: ./src/hooks/useConfig.ts
var useConfig = __webpack_require__(79149);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/hooks/useCalcSigningClient/getClient/clients/cosmos/index.ts + 3 modules
var cosmos = __webpack_require__(77521);
;// CONCATENATED MODULE: ./src/hooks/useCalcSigningClient/getClient/index.ts

function getClient(chainConfig, fetchedConfig, signingClient) {
  return signingClient && fetchedConfig && (0,cosmos/* getCosmosCalcSigningClient */.A)(signingClient, chainConfig, fetchedConfig);
}
;// CONCATENATED MODULE: ./src/hooks/useCalcSigningClient/index.ts


var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function useCalcSigningClient() {
  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId,
      chainConfig = _useChainId.chainConfig;

  var fetchedConfig = (0,useConfig/* useConfig */.Z)();

  var _useWallet = (0,useWallet/* useWallet */.O)(),
      connected = _useWallet.connected,
      getSigningClient = _useWallet.getSigningClient;

  var _useQuery = (0,useQuery/* useQuery */.a)(['signingCosmWasmClient', chainId], getSigningClient, {
    enabled: !!chainId && connected,
    meta: {
      errorMessage: 'Error fetching signing client'
    }
  }),
      signingClient = _useQuery.data,
      other = (0,objectWithoutProperties/* default */.Z)(_useQuery, _excluded);

  return _objectSpread({
    calcSigningClient: getClient(chainConfig, fetchedConfig, signingClient)
  }, other);
}

/***/ }),

/***/ 70302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ handleError; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function getSentryCreateVaultTags(createVaultContext) {
  var _createVaultContext$t, _createVaultContext$t2;

  return _objectSpread(_objectSpread({}, createVaultContext), {}, {
    initialDenom: createVaultContext.initialDenom.name,
    resultingDenom: createVaultContext.resultingDenom.name,
    timeInterval: "".concat(createVaultContext.timeInterval.increment, " ").concat(createVaultContext.timeInterval.interval),
    timeTrigger: "".concat((_createVaultContext$t = createVaultContext.timeTrigger) === null || _createVaultContext$t === void 0 ? void 0 : _createVaultContext$t.startDate, " ").concat((_createVaultContext$t2 = createVaultContext.timeTrigger) === null || _createVaultContext$t2 === void 0 ? void 0 : _createVaultContext$t2.startTime),
    destinationConfig: JSON.stringify(createVaultContext.destinationConfig),
    swapAdjustment: JSON.stringify(createVaultContext.swapAdjustment)
  });
}

function handleError(createVaultContext) {
  return function (error) {
    if (error instanceof Error) {
      if (!error.message.includes('Request rejected')) {
        _sentry_react__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error, {
          tags: getSentryCreateVaultTags(createVaultContext)
        });
        throw new Error(error.message);
      }

      throw new Error('Transaction cancelled');
    }

    throw new Error('Unknown error');
  };
}

/***/ }),

/***/ 11247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useCreateVaultDca; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_checkSwapAmountValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58112);
/* harmony import */ var _helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18081);
/* harmony import */ var _hooks_useCalcSigningClient__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67039);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54456);
/* harmony import */ var _hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47134);
/* harmony import */ var _hooks_useWallet__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5403);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _handleError__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70302);



/* eslint-disable consistent-return */










var useCreateVaultDca = function useCreateVaultDca() {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_4__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var _useStrategyInfo = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_6__/* .useStrategyInfo */ .R0)(),
      transactionType = _useStrategyInfo.transactionType;

  var _useCalcSigningClient = (0,_hooks_useCalcSigningClient__WEBPACK_IMPORTED_MODULE_3__/* .useCalcSigningClient */ .I)(),
      calcSigningClient = _useCalcSigningClient.calcSigningClient;

  var _useWallet = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_7__/* .useWallet */ .O)(),
      address = _useWallet.address;

  var _useFiatPrices = (0,_hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)([chainId]),
      fiatPrices = _useFiatPrices.fiatPrices;

  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)( /*#__PURE__*/function () {
    var _ref2 = (0,_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
      var _state$initialDenom, _fiatPrices$state$ini, _state$initialDenom2;

      var state, reinvestStrategyData, price, _state$initialDenom3, createVaultContext, fee, createResponse;

      return _home_runner_work_app_calculated_fi_app_calculated_fi_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref.state, reinvestStrategyData = _ref.reinvestStrategyData;

              if (state) {
                _context.next = 3;
                break;
              }

              throw new Error('No state');

            case 3:
              if (!(!(0,lodash__WEBPACK_IMPORTED_MODULE_8__.isNil)(state.reinvestStrategy) && !(0,lodash__WEBPACK_IMPORTED_MODULE_8__.isEmpty)(state.reinvestStrategy) && !reinvestStrategyData)) {
                _context.next = 5;
                break;
              }

              throw new Error('Invalid reinvest strategy.');

            case 5:
              if (calcSigningClient) {
                _context.next = 7;
                break;
              }

              throw Error('Invalid client');

            case 7:
              if (state.initialDenom) {
                _context.next = 9;
                break;
              }

              throw Error('Invalid initial denom');

            case 9:
              price = ((_state$initialDenom = state.initialDenom) === null || _state$initialDenom === void 0 ? void 0 : _state$initialDenom.coingeckoId) && (fiatPrices === null || fiatPrices === void 0 ? void 0 : (_fiatPrices$state$ini = fiatPrices[(_state$initialDenom2 = state.initialDenom) === null || _state$initialDenom2 === void 0 ? void 0 : _state$initialDenom2.coingeckoId]) === null || _fiatPrices$state$ini === void 0 ? void 0 : _fiatPrices$state$ini.usd);

              if (price) {
                _context.next = 12;
                break;
              }

              throw Error("Coingecko listing is required for ".concat((_state$initialDenom3 = state.initialDenom) === null || _state$initialDenom3 === void 0 ? void 0 : _state$initialDenom3.name, " in order to evaluate the minimum viable swap amount"));

            case 12:
              if (address) {
                _context.next = 14;
                break;
              }

              throw new Error('No sender address');

            case 14:
              (0,_helpers_checkSwapAmountValue__WEBPACK_IMPORTED_MODULE_1__/* .checkSwapAmountValue */ .u)(chainId, state.swapAmount, price);

              if (state.resultingDenom) {
                _context.next = 17;
                break;
              }

              throw new Error('Invalid resulting denom');

            case 17:
              createVaultContext = {
                initialDenom: state.initialDenom,
                resultingDenom: state.resultingDenom,
                timeInterval: {
                  interval: state.executionInterval,
                  increment: state.executionIntervalIncrement
                },
                timeTrigger: {
                  startDate: state.startDate,
                  startTime: state.purchaseTime
                },
                startPrice: state.startPrice || undefined,
                swapAmount: state.swapAmount,
                route: state.route,
                priceThreshold: state.priceThresholdValue || undefined,
                transactionType: transactionType,
                slippageTolerance: state.slippageTolerance,
                destinationConfig: {
                  autoStakeValidator: state.autoStakeValidator || undefined,
                  autoCompoundStakingRewards: state.autoCompoundStakingRewards,
                  recipientAccount: state.recipientAccount || undefined,
                  yieldOption: state.yieldOption || undefined,
                  reinvestStrategyId: state.reinvestStrategy || undefined,
                  senderAddress: address
                }
              };
              fee = (0,_helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_2__/* .createStrategyFeeInTokens */ .y)(price, state.initialDenom).toFixed(0);
              _context.prev = 19;
              _context.next = 22;
              return calcSigningClient.createStrategy(address, state.initialDeposit, fee, createVaultContext);

            case 22:
              createResponse = _context.sent;
              return _context.abrupt("return", createResponse);

            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](19);
              (0,_handleError__WEBPACK_IMPORTED_MODULE_11__/* .handleError */ .S)(createVaultContext)(_context.t0);

            case 29:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[19, 26]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/***/ }),

/***/ 22149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ StrategyStatus; }
/* harmony export */ });
var StrategyStatus;

(function (StrategyStatus) {
  StrategyStatus["ACTIVE"] = "active";
  StrategyStatus["COMPLETED"] = "completed";
  StrategyStatus["CANCELLED"] = "cancelled";
  StrategyStatus["SCHEDULED"] = "scheduled";
})(StrategyStatus || (StrategyStatus = {}));

/***/ }),

/***/ 69326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LearnAboutCalcPanel": function() { return /* binding */ LearnAboutCalcPanel; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/box/box.mjs
var box = __webpack_require__(68029);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/stack/stack.mjs + 2 modules
var stack = __webpack_require__(3712);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/stack/h-stack.mjs
var h_stack = __webpack_require__(73636);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/image/image.mjs + 2 modules
var image_image = __webpack_require__(32761);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/typography/heading.mjs
var heading = __webpack_require__(50232);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/typography/text.mjs
var typography_text = __webpack_require__(90092);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/button/button.mjs + 3 modules
var button_button = __webpack_require__(38488);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/stack/v-stack.mjs
var v_stack = __webpack_require__(8186);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/icon/icon.mjs
var icon = __webpack_require__(12553);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/grid/grid.mjs
var grid = __webpack_require__(16610);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/grid/grid-item.mjs
var grid_item = __webpack_require__(59099);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 19 modules
var Layout = __webpack_require__(73863);
// EXTERNAL MODULE: ./src/components/LinkWithQuery.tsx
var LinkWithQuery = __webpack_require__(69091);
// EXTERNAL MODULE: ./src/components/RetirementNotice.tsx
var RetirementNotice = __webpack_require__(2281);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/media-query/use-media-query.mjs
var use_media_query = __webpack_require__(90038);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/form-control/form-control.mjs
var form_control = __webpack_require__(54506);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/form-control/form-label.mjs
var form_label = __webpack_require__(30980);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/center/center.mjs
var center = __webpack_require__(15715);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/spacer/spacer.mjs
var spacer = __webpack_require__(14114);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/grid/simple-grid.mjs
var simple_grid = __webpack_require__(43321);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/form-control/form-error.mjs
var form_error = __webpack_require__(54795);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/flex/flex.mjs
var flex = __webpack_require__(88329);
// EXTERNAL MODULE: ./src/models/DcaInFormData.ts
var DcaInFormData = __webpack_require__(89601);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(5380);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/hooks/useValidation.ts
var useValidation = __webpack_require__(62235);
// EXTERNAL MODULE: ./src/hooks/useBalances.ts
var useBalances = __webpack_require__(52560);
// EXTERNAL MODULE: ./src/hooks/useFormStore.ts
var useFormStore = __webpack_require__(48403);
// EXTERNAL MODULE: ./src/models/StrategyType.tsx
var StrategyType = __webpack_require__(94705);
// EXTERNAL MODULE: ./src/components/TransactionType.tsx
var TransactionType = __webpack_require__(95709);
// EXTERNAL MODULE: ./src/components/Spinner/index.tsx
var Spinner = __webpack_require__(12376);
// EXTERNAL MODULE: ./src/formConfig/simpleDcaIn.tsx
var simpleDcaIn = __webpack_require__(2248);
// EXTERNAL MODULE: ./src/hooks/useStrategyInfo.tsx
var useStrategyInfo = __webpack_require__(47134);
// EXTERNAL MODULE: ./src/components/NewStrategyModal/index.tsx + 3 modules
var NewStrategyModal = __webpack_require__(2783);
// EXTERNAL MODULE: ./src/hooks/usePageLoad.ts
var usePageLoad = __webpack_require__(40650);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js + 1 modules
var errorboundary = __webpack_require__(94787);
// EXTERNAL MODULE: ./src/components/Summary/SummaryAgreementForm.tsx
var SummaryAgreementForm = __webpack_require__(18428);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SuccessStrategyModal.tsx + 1 modules
var SuccessStrategyModal = __webpack_require__(37975);
// EXTERNAL MODULE: ./src/components/DenomSelect.tsx
var DenomSelect = __webpack_require__(75872);
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./src/components/AvailableFunds.tsx
var AvailableFunds = __webpack_require__(24497);
// EXTERNAL MODULE: ./src/components/InitialDeposit.tsx
var InitialDeposit = __webpack_require__(45435);
// EXTERNAL MODULE: ./src/hooks/useSteps.ts
var useSteps = __webpack_require__(27317);
// EXTERNAL MODULE: ./src/utils/totalExecutions.tsx
var totalExecutions = __webpack_require__(66260);
// EXTERNAL MODULE: ./src/helpers/executionIntervalDisplay.tsx
var executionIntervalDisplay = __webpack_require__(63961);
// EXTERNAL MODULE: ./src/helpers/getTimeSaved.tsx
var getTimeSaved = __webpack_require__(84333);
// EXTERNAL MODULE: ./src/helpers/format/formatFiat.tsx
var formatFiat = __webpack_require__(50215);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
// EXTERNAL MODULE: ./src/hooks/useDenoms.ts + 7 modules
var useDenoms = __webpack_require__(466);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./node_modules/rambda/src/values.js
var values = __webpack_require__(6285);
// EXTERNAL MODULE: ./src/hooks/useRoute.ts
var useRoute = __webpack_require__(61456);
// EXTERNAL MODULE: ./node_modules/@cosmjs/stargate/build/index.js
var build = __webpack_require__(24658);
// EXTERNAL MODULE: ./src/hooks/useQueryState.ts
var useQueryState = __webpack_require__(9397);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./src/hooks/useCreateVault/useCreateVaultDca/index.ts
var useCreateVaultDca = __webpack_require__(11247);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/react/dist/esm/radio/use-radio-group.mjs
var use_radio_group = __webpack_require__(8194);
;// CONCATENATED MODULE: ./src/helpers/executionIntervalData.tsx
var executionIntervalData = [{
  value: 'hourly',
  label: 'Hour'
}, {
  value: 'daily',
  label: 'Day'
}, {
  value: 'weekly',
  label: 'Week'
}, {
  value: 'monthly',
  label: 'Month'
}];
// EXTERNAL MODULE: ./src/components/Radio.tsx
var Radio = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/RadioCard.tsx
var RadioCard = __webpack_require__(9126);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ExecutionIntervalLegacy.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function ExecutionIntervalLegacy() {
  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'executionInterval'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      helpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 1),
      resultingDenom = _useField4[0].value;

  var _useRadioGroup = (0,use_radio_group/* useRadioGroup */.a)(_objectSpread(_objectSpread({}, field), {}, {
    defaultValue: 'daily',
    onChange: helpers.setValue
  })),
      getRootProps = _useRadioGroup.getRootProps,
      getRadioProps = _useRadioGroup.getRadioProps;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormControl */.NI, {
    isDisabled: !resultingDenom,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(form_label/* FormLabel */.l, {
      children: "Every:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, _objectSpread(_objectSpread({}, getRootProps), {}, {
      children: executionIntervalData.map(function (option) {
        var radio = getRadioProps({
          value: option.value
        });
        return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioCard/* default */.Z, _objectSpread(_objectSpread({
          textAlign: "center"
        }, radio), {}, {
          isDisabled: !resultingDenom,
          children: option.label
        }), option.label);
      })
    }))]
  });
}
// EXTERNAL MODULE: ./src/components/DenomInput.tsx
var DenomInput = __webpack_require__(21964);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(47309);
;// CONCATENATED MODULE: ./src/components/SimpleDcaInForm.tsx




var _excluded = ["onChange", "value"];


function SimpleDcaInForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SimpleDcaInForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SimpleDcaInForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SimpleDcaInForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












































function ModalHeader(_ref) {
  var isSuccess = _ref.isSuccess;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
    size: "sm",
    children: isSuccess ? 'Strategy successfully created!' : 'Setup a simple dollar cost averaging (DCA) strategy'
  });
}

function InitialDenom() {
  var _denoms$chainId, _initialDenom$value, _initialDenom$value2;

  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId;

  var _useDenoms = (0,useDenoms/* default */.Z)([chainId]),
      getDenomById = _useDenoms.getDenomById,
      denoms = _useDenoms.denoms;

  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      initialDenom = _useField2[0],
      meta = _useField2[1],
      initialDenomHelpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 3),
      resultingDenomHelpers = _useField4[2];

  var _useMediaQuery = (0,use_media_query/* useMediaQuery */.a)('(max-width: 506px)'),
      _useMediaQuery2 = (0,slicedToArray/* default */.Z)(_useMediaQuery, 1),
      isMobile = _useMediaQuery2[0];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormControl */.NI, {
    isInvalid: Boolean(meta.touched && meta.error),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(form_label/* FormLabel */.l, {
      children: "Using:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_control/* FormHelperText */.Q6, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(center/* Center */.M, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          textStyle: "body-xs",
          children: "Choose asset to sell"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(spacer/* Spacer */.L, {}), initialDenom.value && /*#__PURE__*/(0,jsx_runtime.jsx)(AvailableFunds/* AvailableFunds */.jk, {
          denom: initialDenom.value
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(simple_grid/* SimpleGrid */.M, {
      columns: 2,
      spacing: 2,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(box/* Box */.x, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
          denoms: (0,usePairs/* orderAlphabetically */.t1)((0,values/* values */.V)((_denoms$chainId = denoms === null || denoms === void 0 ? void 0 : denoms[chainId]) !== null && _denoms$chainId !== void 0 ? _denoms$chainId : {})),
          placeholder: isMobile ? 'Asset' : 'Choose asset',
          defaultValue: (_initialDenom$value = initialDenom.value) === null || _initialDenom$value === void 0 ? void 0 : _initialDenom$value.id,
          value: (_initialDenom$value2 = initialDenom.value) === null || _initialDenom$value2 === void 0 ? void 0 : _initialDenom$value2.id,
          onChange: function onChange(newValue) {
            if (!newValue) return;
            initialDenomHelpers.setValue(getDenomById(newValue));
            resultingDenomHelpers.setValue(undefined);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_error/* FormErrorMessage */.J1, {
          children: meta.touched && meta.error
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InitialDeposit/* default */.Z, {})]
    })]
  });
}

function ResultingDenom(_ref2) {
  var denoms = _ref2.denoms;

  var _useField5 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField6 = (0,slicedToArray/* default */.Z)(_useField5, 3),
      resultingDenom = _useField6[0].value,
      meta = _useField6[1],
      helpers = _useField6[2];

  var _useChainId2 = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId2.chainId;

  var _useDenoms2 = (0,useDenoms/* default */.Z)([chainId]),
      getDenomById = _useDenoms2.getDenomById;

  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      initialDenom = _useFormikContext.values.initialDenom;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormControl */.NI, {
    isInvalid: Boolean(meta.touched && meta.error),
    isDisabled: !initialDenom,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(form_label/* FormLabel */.l, {
      children: "I want to DCA into:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_control/* FormHelperText */.Q6, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
        textStyle: "body-xs",
        children: "CALC will purchase this asset for you"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
      denoms: denoms,
      placeholder: "Choose asset",
      defaultValue: resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.id,
      value: resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.id,
      onChange: function onChange(v) {
        return v && helpers.setValue(getDenomById(v));
      },
      optionLabel: "Swapped on ".concat((0,chains/* getChainDexName */.rB)(chainId))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_error/* FormErrorMessage */.J1, {
      children: meta.touched && meta.error
    })]
  });
}

function SwapAmount(_ref3) {
  var _fromAtomic$toLocaleS;

  var initialDenom = _ref3.initialDenom,
      resultingDenom = _ref3.resultingDenom;

  var _useChainId3 = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId3.chainId;

  var _useField7 = (0,formik_esm/* useField */.U$)({
    name: 'swapAmount'
  }),
      _useField8 = (0,slicedToArray/* default */.Z)(_useField7, 3),
      _useField8$ = _useField8[0],
      onChange = _useField8$.onChange,
      swapAmount = _useField8$.value,
      swapAmountField = (0,objectWithoutProperties/* default */.Z)(_useField8$, _excluded),
      swapAmountMeta = _useField8[1],
      setSwapAmount = _useField8[2].setValue;

  var _useField9 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField10 = (0,slicedToArray/* default */.Z)(_useField9, 2),
      initialDeposit = _useField10[0].value,
      depositMeta = _useField10[1];

  var _useField11 = (0,formik_esm/* useField */.U$)({
    name: 'executionInterval'
  }),
      _useField12 = (0,slicedToArray/* default */.Z)(_useField11, 1),
      executionInterval = _useField12[0].value;

  var _useField13 = (0,formik_esm/* useField */.U$)({
    name: 'route'
  }),
      _useField14 = (0,slicedToArray/* default */.Z)(_useField13, 3),
      routeMeta = _useField14[1],
      routeHelpers = _useField14[2];

  var executions = initialDeposit && swapAmount ? (0,totalExecutions/* default */.Z)(initialDeposit, swapAmount) : 0;
  var displayExecutionInterval = executionInterval && executions > 0 && executionIntervalDisplay/* default */.Z[executionInterval][executions > 1 ? 1 : 0];

  var _useRoute = (0,useRoute/* default */.Z)(swapAmount && initialDenom ? (0,build.coin)(BigInt(swapAmount).toString(), initialDenom.id) : undefined, resultingDenom),
      route = _useRoute.route,
      routeError = _useRoute.routeError,
      routeIsLoading = _useRoute.isLoading;

  (0,react.useEffect)(function () {
    if (routeIsLoading) {
      routeHelpers.setValue(undefined);
      routeHelpers.setTouched(false);
    } else if (routeError) {
      routeHelpers.setTouched(true, false);
      routeHelpers.setError(routeError);
    } else {
      routeHelpers.setValue(route);
      routeHelpers.setTouched(true);
    }
  }, [route, routeError, routeIsLoading]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormControl */.NI, {
    isInvalid: Boolean(swapAmountMeta.touched && swapAmountMeta.error && initialDeposit) || Boolean(routeMeta.touched && routeError),
    isDisabled: !executionInterval || !initialDeposit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(form_label/* FormLabel */.l, {
      children: ["How much ", initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.name, " each purchase?"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormHelperText */.Q6, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(flex/* Flex */.k, {
        alignItems: "flex-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(typography_text/* Text */.x, {
          children: ["The amount you want swapped each purchase for ", resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.name, "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(spacer/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(flex/* Flex */.k, {
          flexDirection: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
            ml: 4,
            mr: 1,
            children: "Max:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
            size: "xs",
            colorScheme: "blue",
            variant: "link",
            cursor: "pointer",
            onClick: function onClick() {
              return setSwapAmount(initialDeposit);
            },
            children: initialDenom && initialDeposit && depositMeta.touched ? (_fromAtomic$toLocaleS = (0,getDenomInfo/* fromAtomic */.b1)(initialDenom, initialDeposit).toLocaleString('en-US', {
              maximumFractionDigits: 6,
              minimumFractionDigits: 2
            })) !== null && _fromAtomic$toLocaleS !== void 0 ? _fromAtomic$toLocaleS : '-' : '-'
          })]
        })]
      }), ' ']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DenomInput/* DenomInput */.h, SimpleDcaInForm_objectSpread(SimpleDcaInForm_objectSpread({
      denom: initialDenom,
      onChange: function onChange(input) {
        return initialDenom && setSwapAmount((0,getDenomInfo/* toAtomic */.Iy)(initialDenom, input !== null && input !== void 0 ? input : 0));
      },
      value: initialDenom && swapAmount && (0,getDenomInfo/* fromAtomic */.b1)(initialDenom, swapAmount)
    }, swapAmountField), {}, {
      isDisabled: !initialDeposit
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormHelperText */.Q6, {
      children: ["Swap amount must be greater than ", (0,formatFiat/* formatFiat */.M)((0,chains/* getChainMinimumSwapValue */.Jd)(chainId))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(form_error/* FormErrorMessage */.J1, {
      children: routeError || swapAmountMeta.error
    }), initialDeposit && !depositMeta.error && depositMeta.touched && swapAmount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(form_control/* FormHelperText */.Q6, {
      color: "brand.200",
      fontSize: "xs",
      children: ["A total of ", executions, " swaps will take place over ", executions, " ", displayExecutionInterval, "."]
    })]
  });
}

function SimpleDCAInForm(_ref4) {
  var formValues = _ref4.formValues;

  var _useWallet = (0,useWallet/* useWallet */.O)(),
      connected = _useWallet.connected;

  var _useSteps = (0,useSteps/* default */.Z)(simpleDcaIn/* default */.Z),
      nextStep = _useSteps.nextStep;

  var _useCreateVaultDca = (0,useCreateVaultDca/* useCreateVaultDca */.E)(),
      mutate = _useCreateVaultDca.mutate,
      isError = _useCreateVaultDca.isError,
      error = _useCreateVaultDca.error,
      isLoading = _useCreateVaultDca.isLoading;

  var _usePageLoad = (0,usePageLoad/* default */.Z)(),
      isPageLoading = _usePageLoad.isPageLoading;

  var _useState = (0,react.useState)(false),
      isSuccess = _useState[0],
      setIsSuccess = _useState[1];

  var _useField15 = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField16 = (0,slicedToArray/* default */.Z)(_useField15, 1),
      initialDenom = _useField16[0].value;

  var _usePairs = (0,usePairs/* default */.ZP)(undefined, initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.id),
      pairs = _usePairs.pairs;

  var _useField17 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField18 = (0,slicedToArray/* default */.Z)(_useField17, 2),
      initialDepositMeta = _useField18[1];

  var _useField19 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField20 = (0,slicedToArray/* default */.Z)(_useField19, 1),
      resultingDenom = _useField20[0].value;

  var _useField21 = (0,formik_esm/* useField */.U$)({
    name: 'route'
  }),
      _useField22 = (0,slicedToArray/* default */.Z)(_useField21, 2),
      routeMeta = _useField22[1];

  var _useQueryState = (0,useQueryState/* default */.Z)(),
      _useQueryState2 = (0,slicedToArray/* default */.Z)(_useQueryState, 2),
      setQueryState = _useQueryState2[1];

  var handleSubmit = function handleSubmit(_, _ref5, state) {
    var setSubmitting = _ref5.setSubmitting;
    return mutate({
      state: state
    }, {
      onSuccess: function () {
        var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(strategyId) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  nextStep({
                    strategyId: strategyId,
                    timeSaved: state && (0,getTimeSaved/* getTimeSaved */.a)(state.initialDeposit, state.swapAmount)
                  });
                  setQueryState({
                    strategyId: strategyId,
                    timeSaved: state && (0,getTimeSaved/* getTimeSaved */.a)(state.initialDeposit, state.swapAmount)
                  });
                  setIsSuccess(true);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onSuccess(_x) {
          return _onSuccess.apply(this, arguments);
        }

        return onSuccess;
      }(),
      onSettled: function onSettled() {
        setSubmitting(false);
      }
    });
  };

  if (!pairs) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(center/* Center */.M, {
      h: 56,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    });
  }

  var resultingDenoms = initialDenom ? (0,usePairs/* getResultingDenoms */.jS)(pairs, initialDenom).filter(function (denom) {
    return denom.id !== (initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.id);
  }) : [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(flex/* Flex */.k, {
    layerStyle: "panel",
    p: {
      base: 0,
      sm: 4
    },
    alignItems: "center",
    justifyContent: "center",
    h: "full",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(box/* Box */.x, {
      maxWidth: 451,
      mx: "auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewStrategyModal/* NewStrategyModalBody */.p9, {
        stepsConfig: simpleDcaIn/* default */.Z,
        isLoading: isPageLoading,
        isSigning: isLoading,
        children: isSuccess ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessStrategyModal/* SuccessStrategyModalBody */.S, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
          direction: "column",
          spacing: 4,
          visibility: isLoading ? 'hidden' : 'visible',
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalHeader, {
            isSuccess: isSuccess
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InitialDenom, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ResultingDenom, {
            denoms: resultingDenoms
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExecutionIntervalLegacy, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SwapAmount, {
            initialDenom: initialDenom,
            resultingDenom: resultingDenom
          }), connected ? /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryAgreementForm/* SummaryAgreementForm */.I, {
            isError: isError,
            error: error,
            onSubmit: function onSubmit(agreementData, setSubmitting) {
              return handleSubmit(agreementData, setSubmitting, formValues);
            },
            isDisabled: !routeMeta.touched || !!routeMeta.error || !initialDepositMeta.touched || !!initialDepositMeta.error
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})]
        })
      })
    })
  });
}

function SimpleDcaIn() {
  var _useBalances = (0,useBalances/* default */.Z)(),
      balances = _useBalances.balances;

  var _useValidation = (0,useValidation/* default */.Z)(DcaInFormData/* simplifiedDcaInValidationSchema */.oP, {
    balances: balances
  }),
      validate = _useValidation.validate;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(useStrategyInfo/* StrategyInfoProvider */.cS, {
    strategyInfo: {
      strategyType: StrategyType/* StrategyType.SimpleDCAIn */.h.SimpleDCAIn,
      transactionType: TransactionType/* TransactionType.Buy */.i.Buy,
      formName: useFormStore/* FormNames.SimpleDcaIn */.Z.SimpleDcaIn
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* BrowserRouter */.VK, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: DcaInFormData/* initialValues */.Sc,
        validate: validate,
        onSubmit: function onSubmit() {},
        children: function children(_ref6) {
          var formValues = _ref6.values;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
            fallback: /*#__PURE__*/(0,jsx_runtime.jsxs)(center/* Center */.M, {
              m: 8,
              p: 8,
              flexDirection: "column",
              gap: 6,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
                size: "lg",
                children: "Something went wrong"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(image_image/* Image */.E, {
                w: 28,
                h: 28,
                src: "/images/notConnected.png"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
                children: "Please try again in a new session"
              })]
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleDCAInForm, {
              formValues: formValues
            })
          });
        }
      })
    })
  });
}
// EXTERNAL MODULE: ./node_modules/@fusion-icons/react/interface/esm/index.js + 297 modules
var esm = __webpack_require__(52597);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(18459);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx












function RujiraPanel() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(box/* Box */.x, {
    layerStyle: "panel",
    p: 8,
    h: "full",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
      spacing: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(h_stack/* HStack */.U, {
        spacing: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(image_image/* Image */.E, {
          src: "/images/denoms/ruji.svg",
          w: 6,
          h: 6
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
          size: "md",
          children: "Try CALC on Rujira"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
        spacing: 1,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          fontSize: "sm",
          children: "Start a cross-chain DCA strategy on Rujira using Thorchain secured assets."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          fontSize: "sm",
          textStyle: "body",
          children: "Native BTC, ETH, AVAX, USDC, USDT, and many more..."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(stack/* Stack */.K, {
        direction: {
          base: 'column',
          sm: 'row'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          as: "a",
          href: "https://rujira.network/trade/RUJI/USDC?order=recurring",
          target: "_blank",
          rel: "noreferrer",
          px: 9,
          size: "sm",
          bgColor: "blue.200",
          _hover: {
            bgColor: 'blue.300'
          },
          children: "Start trading Cross Chain"
        })
      })]
    })
  });
}

function LearnAboutCalcPanel() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(box/* Box */.x, {
    layerStyle: "panel",
    p: 8,
    h: "full",
    backgroundImage: "/images/backgrounds/twist-thin-blue.svg",
    backgroundSize: "cover",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(v_stack/* VStack */.g, {
      alignItems: "left",
      spacing: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(h_stack/* HStack */.U, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icon/* Icon */.J, {
          as: esm/* KnowledgeIcon */.jSc,
          stroke: "blue.200",
          strokeWidth: 5,
          w: 6,
          h: 6
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
          size: "md",
          children: "New to CALC?"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(stack/* Stack */.K, {
        spacing: 1,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          fontSize: "sm",
          children: "Find out why people are raving about their experiences leveraging CALC to make smarter swaps."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
          fontSize: "sm",
          textStyle: "body",
          children: "DCA | DCA+ | Weighted Scale"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(stack/* Stack */.K, {
        direction: {
          base: 'column',
          sm: 'row'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery/* default */.Z, {
          passHref: true,
          href: "/learn-about-calc",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
            px: 12,
            maxWidth: 402,
            size: "sm",
            bgColor: "blue.200",
            _hover: {
              bgColor: 'blue.300'
            },
            children: "Learn how CALC works"
          })
        })
      })]
    })
  });
}

function Home() {
  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId;

  var chainIsRetired = (0,constants/* isChainRetired */.Z8)(chainId);
  var showOsmosisForm = constants/* OSMOSIS_CHAINS.includes */.JP.includes(chainId);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(box/* Box */.x, {
      pb: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(heading/* Heading */.X, {
        size: "lg",
        mb: 2,
        children: "Welcome to CALC"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(typography_text/* Text */.x, {
        textStyle: "body",
        children: chainIsRetired ? 'Manage and recover funds from your existing CALC strategies.' : 'Define your strategy up front, and leave the rest to CALC.'
      })]
    }), chainIsRetired && /*#__PURE__*/(0,jsx_runtime.jsx)(RetirementNotice/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(grid/* Grid */.r, {
      gap: 4,
      mt: chainIsRetired ? 8 : 0,
      templateColumns: "repeat(10, 1fr)",
      alignItems: "stretch",
      children: [showOsmosisForm && /*#__PURE__*/(0,jsx_runtime.jsx)(grid_item/* GridItem */.P, {
        colSpan: [10, 10, 10, 10, 5, 5],
        rowSpan: 2,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleDcaIn, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(grid_item/* GridItem */.P, {
        colSpan: [10, 10, 10, 10, 5, 5],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RujiraPanel, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(grid_item/* GridItem */.P, {
        colSpan: [10, 10, 10, 10, 5, 5],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LearnAboutCalcPanel, {})
      })]
    })]
  });
}

Home.getLayout = Layout/* getSidebarLayout */.M;
/* harmony default export */ var index_page = (Home);

/***/ }),

/***/ 90019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ safeInvert; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

function safeInvert(value) {
  if (!value) {
    return 0;
  }

  if (!(0,lodash__WEBPACK_IMPORTED_MODULE_0__.isNumber)(value)) {
    return 0;
  }

  return 1 / value;
}

/***/ }),

/***/ 66260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var totalExecutions = function totalExecutions(initialDeposit, swapAmount) {
  return Math.ceil(initialDeposit / swapAmount);
};

/* harmony default export */ __webpack_exports__["Z"] = (totalExecutions);

/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(69326);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4644,350,3750,4220,7333,372,8541,8345,3258,7975,4291,9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);